import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormatUrl from "../../../utils/UrlFormatter";
import { getClinicId } from "../../../utils/config";
import "../styles/ViewIntakeForm.css";

const ViewIntakeForm = ({ user }) => {
  const navigate = useNavigate();
  const { patientId, doctorId } = useParams();
  const [medicalHistory, setMedicalHistory] = useState(null);
  const [collapsedSections, setCollapsedSections] = useState({});
  const clinicId = getClinicId(user);

  useEffect(() => {
    const effectiveRole = user?.role || localStorage.getItem("userRole");
    if (!["DO", "CO", "CA"].includes(effectiveRole)) {
      navigate("/");
    }
    
  }, [user, navigate]);

  useEffect(() => {
    const fetchIntakeForm = async () => {
      try {
        const queryParams = new URLSearchParams({
          clinic_id: clinicId,
          patient_id: patientId,
          practitioner_id: doctorId,
        });

        const response = await fetch(
          FormatUrl(`/get-patient-intake-form/?${queryParams}`),
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );

        const data = await response.json();
        if (data.status === "Success" && data.medical_history) {
          const parsed = JSON.parse(data.medical_history);
          setMedicalHistory(parsed);
        } else {
          setMedicalHistory({}); // explicitly show empty state
        }
      } catch (err) {
        console.error("Error loading intake form:", err);
        setMedicalHistory({}); // treat error as empty
      }
    };

    fetchIntakeForm();
  }, [clinicId, patientId, doctorId]);

  const toggleSection = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  if (medicalHistory === null) {
    return <p style={{ padding: "1rem" }}>Loading intake form...</p>;
  }

  if (Object.keys(medicalHistory).length === 0) {
    return (
      <div className="view-intake-wrapper">
        <h2>Patient Health History Summary</h2>
        <p className="no-intake-message" style={{color:'var(--red-dark)'}}>
        This patient has not completed their health history intake form yet.
        </p>
      </div>
    );
  }

  return (
    <div className="view-intake-wrapper">
      <h2>Patient Health History Summary</h2>

      {Object.entries(medicalHistory).map(([section, fields]) => (
        <div key={section} className="view-intake-section">
          <div
            className="view-intake-section-header"
            onClick={() => toggleSection(section)}
          >
            <h3>{section.replace(/_/g, " ").toUpperCase()}</h3>
            <span className="view-intake-toggle-icon">
              {collapsedSections[section] ? "+" : "−"}
            </span>
          </div>

          {!collapsedSections[section] && (
            <ul className="view-intake-fields">
              {Object.entries(fields).map(([key, value]) => (
                <li key={key}>
                  <strong>{key.replace(/_/g, " ")}:</strong> {value || "--"}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default ViewIntakeForm;
